var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-sm",on:{"click":_vm.deleteCop}},[_c('i',{staticClass:"fa fa-trash"})])])}
var staticRenderFns = []

export { render, staticRenderFns }